import { api } from 'api/client';
import { API_ENDPOINTS } from 'config/api.config';
import { Segment } from 'types/push.types';
import {
  GlobalSegmentCreateRequest,
  GlobalSegmentTestRequest,
  GlobalSegmentTestResponse,
  GlobalSegmentsListResponse,
} from 'types/global_segments.types';
import { SuccessResponse } from 'types/api.types';

export const globalSegmentsApi = {
  list: async (): Promise<GlobalSegmentsListResponse> => {
    const response = await api.get<GlobalSegmentsListResponse>(
      API_ENDPOINTS.globalSegments.list,
    );
    return response.data;
  },

  get: async (id: number): Promise<Segment> => {
    const response = await api.get<Segment>(
      API_ENDPOINTS.globalSegments.get(id),
    );
    return response.data;
  },

  create: async (
    data: GlobalSegmentCreateRequest,
  ): Promise<SuccessResponse & { segment: Segment }> => {
    const response = await api.post<SuccessResponse & { segment: Segment }>(
      API_ENDPOINTS.globalSegments.create,
      data,
    );
    return response.data;
  },

  update: async (
    id: number,
    data: Partial<GlobalSegmentCreateRequest>,
  ): Promise<SuccessResponse & { segment: Segment }> => {
    const response = await api.put<SuccessResponse & { segment: Segment }>(
      API_ENDPOINTS.globalSegments.update(id),
      data,
    );
    return response.data;
  },

  delete: async (id: number): Promise<SuccessResponse> => {
    const response = await api.delete<SuccessResponse>(
      API_ENDPOINTS.globalSegments.delete(id),
    );
    return response.data;
  },

  test: async (
    data: GlobalSegmentTestRequest,
  ): Promise<GlobalSegmentTestResponse> => {
    const response = await api.post<GlobalSegmentTestResponse>(
      API_ENDPOINTS.globalSegments.test,
      data,
    );
    return response.data;
  },
};